export default __webpack_public_path__ + "static/media/share.cfe51131.png";